var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldDisplay)?_c('span',{staticClass:"invite-link",attrs:{"alt":_vm.contactGuid},on:{"click":function($event){return _vm.handleClick()}}},[_vm._v(" Invite to Platform ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }